import React, {  useState } from "react";
import { useDropzone } from "react-dropzone";
import { useController } from "react-hook-form";
import { makeStyles } from "@material-ui/core/styles";
import { withTranslation } from 'react-i18next'
import { IconButton } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import XLSX from 'xlsx';

import { 
    List,
    ListItem,
    ListItemText,
    ListItemIcon,
    Button,
    Grid,
    // Box
} from '@material-ui/core';

import { 
    InsertDriveFile,
    Error
} from '@material-ui/icons'

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: "#eee",
        textAlign: "center",
        cursor: "pointer",
        color: "#333",
        width: "380px",
        padding: "10px",
        border: `1px solid ${theme.palette.primary.main}`,
        '&:hover': {
            backgroundColor: `${theme.palette.primary.grey}`,
        },

        [theme.breakpoints.down('md')]: {
            width: '100%'
        }
    },
    icon: {
        marginTop: "16px",
        color: "#888888",
        fontSize: "42px",
    },
    deleteButton: {
        display: 'flex',
    },
    button: {
        textTransform: "initial"
    },
    fileRejected: {
        color: "#FF0000"
    }
}));

export default withTranslation()(function FileInput({t, control, name, maxFiles, fileType, state, stateKey, onChange, page}) {
    const [ customFileRejections, setCustomFileRejections ] = useState([]);
    
    const styles = useStyles();
    
    const fileSizeCheck = (file) => {
        console.log(file);
        console.log(Buffer.byteLength(file.name, 'utf8'));
      
        //check file size according to file type
        //check file name not exceed length limit (2024-12-17: set to 100 byte, only for uploaded proofs)
        if (file.type === "image/png" || file.type === "application/pdf") {
            if (file.size > 1048576) {
                return {
                    code: "size-too-large",
                    message: `${t("fileInput.pngpdfSize")}`
                };
            }

            if(Buffer.byteLength(file.name, 'utf8')>100){
                return {
                    code: "name-too-long",
                    message: `${t("fileInput.fileNameLength")}`
                };
            }
        }
        if (file.type === "image/jpeg") {
            if (file.size > 5242880) {
                return {
                    code: "size-too-large",
                    message: `${t("fileInput.jpegSize")}`
                }
            }

            if(Buffer.byteLength(file.name, 'utf8')>100){
                return {
                    code: "name-too-long",
                    message: `${t("fileInput.fileNameLength")}`
                };
            }
        }
        return null;
    };
    
    const { field } = useController({
        name,
        control,
        defaultValue: []
    })
    const {
        acceptedFiles,
        fileRejections,
        getRootProps,
        getInputProps,
    } = useDropzone({
        accept: fileType,   
        maxFiles: maxFiles,
        validator: fileSizeCheck,
        onDrop: (onDropFiles) => {
            console.log("onDropFiles: ", onDropFiles);
            return onDropFiles; 
        },
        onDropAccepted: (files) => {
            console.log("onDropAccepted: ", {files, page});
            const typeA = ["locationDetail", "vehicleDetail"];
            const typeB = ["permitDetail", "applicationDetail"];
            
            if (typeA.includes(page)) { 
                console.log("locationDetail");
                return locationDetail(files, page);
            }
            else if (typeB.includes(page)) { 
                console.log("permitDetail");
                return permitDetail(files);
            }
            else {
                return;
            }
        }
    });

    function permitDetail(files) {
        if(onChange){
            onChange(files);
        }
        field.onChange([...field.value ,...files]);
        return files;
    }

    function locationDetail (files) {
        const xlsx = '.spreadsheetml.sheet'
        const xls = 'ms-excel'

        if (files && files.length === 1) {
            if (files[0].type.includes(xlsx) || files[0].type.includes(xls)) {
                // console.log('excel',files[0])
                excelToJson(files[0], page)
            }
        }
    }

    function excelToJson(file, page) {
        var reader = new FileReader();

        reader.readAsArrayBuffer(file)
        reader.onload = function(e) {
            var data = new Uint8Array(e.target.result);
            var workbook = XLSX.read(data, { type: 'array' });
            var first_worksheet = workbook.Sheets[workbook.SheetNames[0]];

            let header = [];
            if(page === 'locationDetail'){
                header = ["streetNo", "streetName", "district", "remarks", "permitType1"];
            } else {
                header = [ "vehicleRegNo", "issueDate"];
            }
            const wsData = XLSX.utils.sheet_to_json(first_worksheet, {"range": "A1:I11", header});
            const newWsData = [];
            for (let index = 1; index < wsData.length; index++) {
                const object = wsData[index];
                let newObject = {};
                for (const [key, value] of Object.entries(object)) {
                    console.log(`${key}: ${value}`);
                    newObject[key] = value.toString();
                }
                console.log("excel json newObject", newObject);
                newWsData.push(newObject);
            }
            // console.log('newWsData: @fileInput', newWsData)
            
            let newState = state;
            let tempLocationGp = [].concat(newWsData);
            // checks for undefined
            newState[stateKey] = tempLocationGp.filter(function (element) {
                return element !== undefined;
            });

            if (page === 'locationDetail') {
                newState = modifyLocationGpObject(newState)
                return (onChange({[stateKey]: newState[stateKey]}))
            }
            return onChange({[stateKey]: newState[stateKey]});
        };
    } 

    function modifyLocationGpObject(obj) {
        let modifiedArr = obj.locationGp.map((location) => {
            let restrictedZone = false;
            let prohibitedZone = false;
            let busLane = false;
            let closeRoad = false;
            let permitType = '';
            if(location.permitType1){
                switch (location.permitType1) {
                    case "Restricted Zone":
                        permitType = 'restricted';
                        break;
                    case "Prohibited Zone":
                        permitType = 'prohibited';
                        break;
                    case "Bus Lane":
                        permitType = 'bus';
                        break;
                    case "Close Road":
                        permitType = 'close';
                        break;
                    default:
                        break;
                }
            }
            return {...location, 
                permitType,
                remarks: location.remarks?location.remarks:""
            }
        });
        
        // console.log(modifiedArr)
        // for (let i=0; i<modifiedArr.length; i++) {
        //     for (var keys in modifiedArr[i]) {
        //         if (modifiedArr[i].hasOwnProperty('restricted', 'prohibited', 'bus', 'close')) {
        //             delete modifiedArr[i].bus 
        //             delete modifiedArr[i].prohibited 
        //             delete modifiedArr[i].bus 
        //             delete modifiedArr[i].close
        //         }
        //     }
        // }
        // console.log(modifiedArr)
        return {locationGp: modifiedArr}
    }

    console.log("fileRejections: ", fileRejections);

    const mergedFileRejections = [...fileRejections, ...customFileRejections];

    const fileRejectionItems = fileRejections.map(({ file, errors  }) => { 
        return (
            <ListItem key={file.path}>
                <Grid container spacing={1}>
                    <Grid item xs={1}><Error /></Grid>
                    <Grid className={styles.fileRejected} item xs={8}>{t("fileInput.rejected") + file.path}</Grid>
                    <Grid className={styles.fileRejected} item xs>{t("fileInput.rejectedReason") + errors[0].message}</Grid>
                </Grid>
                {/* <Error />
                <ListItemIcon>
                    <Error />
                </ListItemIcon>
                <ListItemText 
                    primary={"File Rejected: " + file.path} 
                />
                <ListItemText primary={"Reason: " + errors[0].message} /> */}
            </ListItem>
        ) 
    });

    const deleteFile = (file) => () => {
        // for display
        const newFiles = [...field.value];
        newFiles.splice(newFiles.indexOf(file), 1);
        field.onChange(newFiles);

        // for const
        acceptedFiles.splice(acceptedFiles.indexOf(file), 1);
        console.log('accepted files', acceptedFiles);
    }

    return (
        <>
            {maxFiles>0 &&
            <Button
                variant="outlined"
                id={name}
                className={styles.button}
                {...getRootProps()}
            >
                <input 
                    {...getInputProps()} 
                    name={name}
                    id={name}
                />
                <p>{t('common.fileUploadMsg')}</p>
            </Button>
            }
            {/* <form action="/action_page.php">
                <input type="file" id="myFile" name="filename"/>
                <input type="submit"/>
            </form> */}
            <List>
                { (field.value) && field.value.map((file, index) => {
                    return (
                        <div className={styles.deleteButton} 
                             key={file.id} 
                             id={file.id}
                             file={file}
                             inputRef={field.ref}
                        > 
                            <ListItem>
                                <ListItemIcon>
                                    <InsertDriveFile />
                                </ListItemIcon>
                                <ListItemText 
                                    primary={file.name} 
                                    secondary={file.size} 
                                />
                                <IconButton aria-label="delete" 
                                    onClick={deleteFile(file)}> 
                                    <DeleteIcon />
                                </IconButton>
                            </ListItem>
                        </div>
                    )
                })}
            </List>
            <List>
                {fileRejectionItems}
            </List>
        </>
    );
});
